import { ClockCounterClockwise } from "@phosphor-icons/react";
import { useState } from "react";

import { SplitButton } from "common/components/SplitButton";
import { Licenses } from "common/components/subscriptions";

import { useCampaignContext } from "../../../../../context/CampaignContext";
import useCampaignValidation from "../../../../../hooks/useCampaignValidation";
import CampaignStart from "./CampaignStart";

export default function StartCampaignButton() {
  const [isLicensesModalOpen, setIsLicensesModalOpen] = useState(false);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isScheduled, setIsScheduled] = useState<boolean>();

  const { owners } = useCampaignContext();

  const {
    workerAccountsWithoutSeat,
    missingSeatsCount,
    hasInsufficientLicenses,
  } = useCampaignValidation(owners);

  function onStartCampaign(shouldSchedule: boolean) {
    if (hasInsufficientLicenses) {
      setIsLicensesModalOpen(true);
      return;
    }

    setIsScheduled(shouldSchedule);
    setIsDialogOpen(true);
  }

  return (
    <>
      <SplitButton
        onClick={() => onStartCampaign(false)}
        dropdownMenuItems={[
          {
            label: "Schedule campaign",
            icon: ClockCounterClockwise,
            onSelect: () => onStartCampaign(true),
          },
        ]}
      >
        Start
      </SplitButton>
      <Licenses
        isOpen={isLicensesModalOpen}
        setIsOpen={setIsLicensesModalOpen}
        accountIds={workerAccountsWithoutSeat.map(({ id }) => id)}
        newSeatsCount={missingSeatsCount}
      />

      <CampaignStart
        isOpen={isDialogOpen}
        isScheduled={isScheduled}
        onClose={() => setIsDialogOpen(false)}
      />
    </>
  );
}
